import { Component } from '@angular/core';

@Component({
  selector: 'app-employee-employer-benefits',
  templateUrl: './employee-employer-benefits.component.html',
  styleUrls: ['./employee-employer-benefits.component.scss',],
})
export class EmployeeEmployerBenefitsComponent {

  employeeBenefits = [
    { icon: 'taxes-icon.svg', label: 'Up to 30% tax benefits.', },
    { icon: 'tax-benefit-icon.svg', label: 'Save taxes on their existing car or take a pre-owned car on lease to save taxes.', },
    { icon: 'car-models.svg', label: 'Employees can drive the car of their aspiration.', },
    { icon: 'service-icon.svg', label: 'Only pay for usage – Resale Value benefit given back to Employees.', },
    { icon: 'lease-car-icon.svg', label: 'End to End Maintenance, service, insurance and other value-added services are included in the monthly lease rental.', },
    { icon: 'calender-icon.svg', label: 'Most flexible foreclosure.', },
  ];

  employerBenefits = [
    { icon: 'all-benefits-icon.svg', label: 'Employees save additional 30% on Taxes.', },
    { icon: 'taxes-icon.svg', label: 'Completely cost neutral.', },
    { icon: 'Employee-icon.svg', label: 'Proven talent attraction and retention tool.', },
    { icon: 'car-lease-graph-icon.svg', label: 'Easy transfer option on employee separation.', },
    { icon: 'keys-icon.svg', label: 'Simplified Budgeting as one lease rental includes all costs.', },
    { icon: 'digital-dashboard-icon.svg', label: 'Off balance sheet transaction since it’s an Operating Lease.', },
    { icon: 'reducing-risk-graph-icon.svg', label: 'Minimal Paperwork and Seamless management through Dashboard & Mobile app.    ', },

  ];
}
